const init = () => {
  const campaignButtonsList = document.querySelectorAll('.js-campaign-button');
  if (campaignButtonsList.length) {
    campaignButtonsList.forEach(el => {
      el.addEventListener('click', function (e) {
        onCampaignButtonClick(e.target);
      });
    });
  }
};

const onCampaignButtonClick = btn => {
  let activeForm = btn.parentElement.parentElement;
  let activeCard = btn.parentElement.parentElement.parentElement;

  if (btn.dataset.tocard) {
    showNextCard(btn, activeForm, activeCard);
  }
  if (btn.dataset.previouscard) {
    showPreviousCard(btn, activeCard);
  }
};

const showNextCard = (btn, activeForm, activeCard) => {
  var nextCardId = btn.dataset.tocard;
  var radiosList = activeForm.querySelectorAll(`input[type="radio"]`);
  for (let j = 0; j < radiosList.length; j++) {
    if (radiosList[j].checked) {
      if (btn.dataset.tocard !== 'fin') {
        activeCard.classList.remove('show');
        activeCard.classList.add('shown');
        let nextCard = document.querySelector(`#${nextCardId}`);
        nextCard.classList.add('show');
        getCardIndicator(nextCardId);
      }
    }
  }
};

const showPreviousCard = (btn, activeCard) => {
  var previousCardId = btn.dataset.previouscard;
  activeCard.classList.remove('show');
  let previousCard = document.querySelector(`#${previousCardId}`);
  previousCard.classList.remove('shown');
  previousCard.classList.add('show');
  getCardIndicator(previousCardId);
};

const getCardIndicator = forCard => {
  const indicatorList = document.querySelectorAll('[data-forcard]');
  indicatorList.forEach(indicator => {
    if (indicator.dataset.forcard == forCard) {
      indicator.classList.remove('bg-gray-600');
      indicator.classList.add('bg-red');
    } else {
      indicator.classList.add('bg-gray-600');
      indicator.classList.remove('bg-red');
    }
  });
};

const campainCardsSwap = {
  init,
};

export default campainCardsSwap;
